import HTML from "../assets/html.png";
import CSS from "../assets/css.png";
import JavaScript from "../assets/javascript.png";
import ReactImg from "../assets/react.png";
import Node from "../assets/node.png";
import FireBase from "../assets/firebase.png";
import GitHub from "../assets/github.png";
import Tailwind from "../assets/tailwind.png";
import Mongo from "../assets/mongo.png";

export const skills = [
  {
    id: "1",
    tech: "HTML",
    img: HTML,
  },
  {
    id: "2",
    tech: "CSS",
    img: CSS,
  },
  {
    id: "3",
    tech: "JavaScript",
    img: JavaScript,
  },
  {
    id: "4",
    tech: "React",
    img: ReactImg,
  },
  {
    id: "5",
    tech: "GitHub",
    img: GitHub,
  },
  {
    id: "6",
    tech: "Node Js",
    img: Node,
  },
  {
    id: "7",
    tech: "Mongo DB",
    img: Mongo,
  },
  {
    id: "8",
    tech: "Tailwind",
    img: Tailwind,
  },
  {
    id: "9",
    tech: "FireBase",
    img: FireBase,
  },
];
